import React from 'react';
import { Permission } from '../../../api/roles.dao';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import DefaultButton from '../default-button/default-button';

interface IProps {
    permission: Permission;
    onClick: () => void;
    label: string | object;
}

const AddNewEntityButton = (props: IProps) => {
    const {
        permission,
        onClick,
        label,
    } = props;

    return hasPermission(permission) && (
        <DefaultButton
            className='add-line-to-table-btn'
            text={label}
            onClick={onClick}
        />
    );
};

export { AddNewEntityButton };